// extracted by mini-css-extract-plugin
export default {"general":"producers_general__fu2Bm","container":"producers_container__oEYVc"};